import {
  dateNotInPast,
  fieldNotEmpty,
  isValidMobileNumber
} from '../../utils/fieldValidations';
import { DAY_DURATION, formatDate } from '../../utils/timeUtils';
import { FormInputField } from '../InputField/types';

export const FormFields: Record<string, string> = {
  FULL_NAME: 'fullName',
  MOBILE_NUMBER: 'mobileNumber',
  FROM: 'from',
  TO: 'to',
  PICKUP_DATE: 'pickUpDate',
  SPECIAL_REQUEST: 'specialRequest'
};

export const FieldConfig: Record<string, FormInputField> = {
  [FormFields.FULL_NAME]: {
    key: [FormFields.FULL_NAME],
    defaultValue: '',
    type: 'text',
    label: 'Full Name',
    validators: []
  },
  [FormFields.MOBILE_NUMBER]: {
    key: [FormFields.MOBILE_NUMBER],
    defaultValue: '',
    type: 'mobileText',
    label: 'Mobile No.',
    validators: [fieldNotEmpty, isValidMobileNumber]
  },
  [FormFields.FROM]: {
    key: [FormFields.FROM],
    defaultValue: '',
    type: 'text',
    label: 'From',
    validators: [fieldNotEmpty]
  },
  [FormFields.TO]: {
    key: [FormFields.TO],
    defaultValue: '',
    type: 'text',
    label: 'To',
    validators: []
  },
  [FormFields.PICKUP_DATE]: {
    key: [FormFields.PICKUP_DATE],
    defaultValue: formatDate(new Date(new Date().getTime() + DAY_DURATION)),
    type: 'date',
    label: 'Pick-up Date',
    validators: [dateNotInPast]
  },
  [FormFields.SPECIAL_REQUEST]: {
    key: [FormFields.SPECIAL_REQUEST],
    defaultValue: '',
    type: 'textarea',
    label: 'Any Special Request (Optional)'
  }
};
